export default __webpack_public_path__ + "static/media/bambooHR.45ffd948.svg";